import { useState, type PropsWithChildren } from "react";

interface CollapsibleSectionProps extends PropsWithChildren {
  pageKey: string;
  sectionId: string;
  eyebrow: string;
  title: string;
  defaultOpen?: boolean;
}

export function CollapsibleSection({ pageKey, sectionId, eyebrow, title, defaultOpen = false, children }: CollapsibleSectionProps) {
  const storageKey = `fp:section:v1:${pageKey}:${sectionId}`;
  const [open, setOpen] = useState(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored === null ? defaultOpen : stored === "open";
    } catch { return defaultOpen; }
  });
  return (
    <details className="content-panel collapsible-panel" id={sectionId} open={open} onToggle={(event) => {
      const next = event.currentTarget.open;
      setOpen(next);
      try { localStorage.setItem(storageKey, next ? "open" : "closed"); } catch { /* optional preference storage */ }
    }}>
      <summary><span><small>{eyebrow}</small>{title}</span></summary>
      {children}
    </details>
  );
}
